<template>
  <div
    class="d-flex flex-column contenedor"
    :style="cssVars"
    @click="direccionamiento"
  >
    <div class="d-flex align-items-center step">
      <!-- Linea izquierda -->
      <div class="line" v-if="!first"></div>
      <div class="line-out" v-else></div>

      <!-- Contenido circulo -->
      <div class="circulo" :class="[{ active: active }, { scaleEfect: scale }]">
        <!-- Contador -->
        <div class="contenedor-contador">
          <div class="contador" v-text="counter"></div>
        </div>

        <!-- Icono -->
        <div
          class="d-flex align-items-center justify-content-center w-100 h-100 icon"
        >
          <i :class="[icon]"></i>
        </div>
      </div>

      <!-- Linea derecha -->
      <div class="line" v-if="!last"></div>
    </div>
    <div
      class="texto"
      :class="{ activeText: active }"
      style="min-height: 50px; !important"
      v-text="text"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    icon: { type: String },
    counter: { type: Number, default: 0 },
    text: { Type: String, default: "." },
    first: Boolean,
    last: Boolean,
    size: { type: Number, default: 25 },
    width: { type: Number, default: 30 },
    url: { type: String },
    scale: Boolean,
    color: { Type: String, default: "#dc3545" },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapState(["url_actual"]),
    cssVars() {
      return {
        "--size": this.size + "px",
        "--width": this.width + "px",
        "--color": this.color,
      };
    },
  },
  methods: {
    direccionamiento() {
      this.$router.push({ path: "/lineas/booking/" + this.url }).catch(()=>{});
    },

    
    // Verifica la url una vez que se recarga la pagina
    verificacionUrl() {
      if (this.url_actual.split("/")[3] == this.url) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
  },

  mounted() {
    this.verificacionUrl();
  },

  watch: {
    url_actual: function (_new) {
      if (_new) {
        if (_new.split("/")[3] == this.url) {
          this.active = true;
        } else {
          this.active = false;
        }
      }
    },
  },
};
</script>

<style>
.contenedor {
  cursor: pointer;
  width: 128px;
}

.contenedor-contador {
  position: relative;
}

.contador {
  position: absolute;
  background: var(--color);
  width: 25px;
  height: 25px;
  color: #fff;
  text-align: center;
  border-radius: 100%;
  right: -13px;
  top: -7px;
  padding-top: 2px;
  font-size: 13px;
}

.line {
  height: 2px;
  background: grey;
  width: 36px;
}
.line-out {
  margin-left: 35px;
}

.circulo {
  border-radius: 100%;
  border: 3.5px solid;
  border-color: grey;
  opacity: 0.7;
  transition: 0.3s;
  width: var(--width);
  height: var(--width);
  transition: 0.3s;
}

.circulo:hover {
  opacity: 1;
  transition: 0.3s;
}

.circulo:hover i {
  opacity: 1;
  transition: 0.3s;
}

.icon i {
  font-size: var(--size);
}
.scaleEfect:hover > .icon > i {
  transform: scale(1.3);
  transition: 0.3s;
}

.texto {
  font-size: 0.73rem;
  justify-content: center;
  text-align: center;
  padding: 0px 2px;
  font-weight: 600;
}

.active {
  animation: pulso 1.5s infinite;
}

.activeText {
  animation: pulsoText 1.5s infinite;
}

@keyframes pulso {
  0% {
    border-color: grey;
    opacity: 1;
  }
  50% {
    border-color: var(--color);
    opacity: 1;
  }
  100% {
    border-color: grey;
    opacity: 1;
  }
}

@keyframes pulsoText {
  0% {
    color: grey;
    opacity: 1;
  }
  50% {
    color: var(--color);
    opacity: 1;
  }
  100% {
    color: grey;
    opacity: 1;
  }
}
</style>
